import { MessagesContext } from "contexts/MessagesContext";
import { useContext } from "react";

export function useMessages() {
  const context = useContext(MessagesContext);
  return context;
}
